export const locationTitleContainer = {
    mt: '16px'
}

export const titleText = {
    fontSize: '21px',textAlign:"center"
}

